module.exports = __webpack_public_path__ + "img/shipo-icon-empty.71023cae.svg";